import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
}



// WEBPACK FOOTER //
// ./src/app/shared-layout/footer/footer.component.ts